export interface DetectDeviceTypeRequestPayloadDto {
  IpAddressOrDns: string;
  Username: string;
  Password: string;
  TimeOutInMilliseconds: number;
}

export const DefaultDetectDeviceTypeRequestPayloadDto: DetectDeviceTypeRequestPayloadDto =
  {
    IpAddressOrDns: "",
    Username: "",
    Password: "",
    TimeOutInMilliseconds: 30000,
  };
